import React, { useEffect, useState } from 'react';
import api from '../../../api/api';
const names = {available:'Свободны', rented:'В аренде', maintenance:'В ремонте', unavailable:'Недоступны'};
export default function AssetStatusSummary({refreshKey}) {
  const [statuses,setStatuses] = useState([]);
  useEffect(() => {
    let active = true;
    api.get('/dashboard/overview', {skipLoading:true}).then(({data}) => {
      if(active) setStatuses(data.asset_statuses || []);
    }).catch(() => {if(active) setStatuses([]);});
    return () => {active=false;};
  }, [refreshKey]);
  if(!statuses.length) return null;
  return <dl className="erp-inventory-summary" aria-label="Активы компании по статусам, без фильтров списка">
    <div><dt>Всего в учёте</dt><dd>{statuses.reduce((sum,item) => sum+item.count,0)}</dd></div>
    {statuses.map(item => <div key={item.name}><dt>{names[item.name] || item.name}</dt><dd>{item.count}</dd></div>)}
  </dl>;
}
